export const patternString = <any>{
  text: '.{2,}',
  username: '.{2,}',
  name: '.{2,}',
  lastname: '.{2,}',
  email: "^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$",
  code: '[a-zA-Z0-9]{1}',
  numeric: '^[0-9]*$',
  phone: '^(\\d{3}[- .]?){2}\\d{4}$',
}